var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppleGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7303_2035)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75951 1.60643C9.94241 0.0476487 11.5874 0.0410156 11.5874 0.0410156C11.5874 0.0410156 11.8328 1.50693 10.6566 2.91757C9.40292 4.42549 7.9768 4.17785 7.9768 4.17785C7.9768 4.17785 7.70927 2.99274 8.76172 1.60643H8.75951Z",
    fill: "#858894"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.12495 5.20589C8.73298 5.20589 9.86282 4.37012 11.3332 4.37012C13.8626 4.37012 14.8597 6.1699 14.8597 6.1699C14.8597 6.1699 12.914 7.16486 12.914 9.57931C12.914 12.3033 15.3395 13.243 15.3395 13.243C15.3395 13.243 13.6437 18.0144 11.3553 18.0144C10.3028 18.0144 9.48694 17.3046 8.377 17.3046C7.26707 17.3046 6.12618 18.0409 5.39654 18.0409C3.3049 18.0409 0.66272 13.5149 0.66272 9.87779C0.66272 6.24065 2.89807 4.42097 4.99634 4.42097C6.36054 4.42097 7.41742 5.2081 8.12716 5.2081L8.12495 5.20589Z",
    fill: "#858894"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7303_2035"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.6746,
    height: 18,
    fill: "white",
    transform: "translate(0.66272 0.0410156)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleGray);
export default __webpack_public_path__ + "static/media/apple_gray.31f7932cc40848755e3e6b89982e6039.svg";
export { ForwardRef as ReactComponent };